var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 65,
    viewBox: "0 0 50 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 8C40.414 8 42.621 8 44.2064 9.07066C44.8928 9.53416 45.4821 10.1298 45.9407 10.8234C47 12.4258 47 14.6564 47 19.1176V49.2941C47 55.2837 47 58.2785 45.159 60.1393C43.3179 62 40.3548 62 34.4286 62H15.5714C9.6452 62 6.68209 62 4.84104 60.1393C3 58.2785 3 55.2837 3 49.2941V19.1176C3 14.6564 3 12.4258 4.05933 10.8234C4.51793 10.1298 5.10722 9.53416 5.79356 9.07066C7.37896 8 9.58598 8 14 8",
    stroke: "#BDBDBD",
    strokeWidth: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C16 5.46243 18.6863 3 22 3H28C31.3137 3 34 5.46243 34 8.5C34 11.5376 31.3137 14 28 14H22C18.6863 14 16 11.5376 16 8.5Z",
    stroke: "#BDBDBD",
    strokeWidth: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31L34 31",
    stroke: "#BDBDBD",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43L28 43",
    stroke: "#BDBDBD",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewInfo);
export default __webpack_public_path__ + "static/media/reviewInfo.aa21e8f6.svg";
export { ForwardRef as ReactComponent };